const HAV_COOKIE_NAME = 'hav';
const ADL_WHITELIST = [
    'appname',
    'appversion',
    'fssessionurl',
    'publicuuid',
    'sessionid',
    'visitorid',
    'numchildren',
    'numadults',
    'numinfants',
    'gbsessionurl',
    'visitortype',
    'ownertype',
    'pmid',
    'item4'
];

class OpinionLab {
    /**
     *
     * @param {string} name - Name of the cookie, which will be interpolated
     * into regular expression that will be used to query the document.cookie
     * string.
     * @returns {(string|null)} Cookie value by name if exists, otherwise null.
     */
    getCookie = (name) => {
        const cookieRegExp = new RegExp(`${name }=([^;]+)`);
        const value = cookieRegExp.exec(document.cookie);
        return (value !== null) ? decodeURIComponent(value[1]) : null;
    }

    checkState = (cb, script) => {
        const state = script.readyState;

        if (!state || (/complete/).test(state)) {
            return cb;
        }
        return function() {
            throw new Error('OpinionLab global object not present');
        };
    }

    loadScript = (cb, source) => {
        if (document.getElementById('opinionlab')) {
            return;
        }

        let script = document.createElement('script');
        let src = source || '//csvcus.homeaway.com/rsrcs/stab-feedback/1.2.2/javascripts/opinionlab/oo_engine.min.js';
        script.type = 'text/javascript';

        script.onload = this.checkState(cb, script);
        script.id = 'opinionlab';

        script.src = src;
        (document.body || document.head).appendChild(script);
        return script; // eslint-disable-line consistent-return
    }

    createLauncher = (event) => {
        OpinionLab.cleanUpFormElement();
        const windowOOo = window.OOo;
        if (windowOOo) {
            let options = {
                customVariables: {}
            };
            const ADL = window.analyticsdatalayer;
            const newFSSessionUrl = this.regenerateFullStorySessionUrl();

            if (ADL) {
                // It is necessary to encode ADL values
                // because the presence of commas will break
                // OL's parser resulting in loss of the ADL
                // custom variable
                ADL_WHITELIST
                    .forEach((key) => {
                        if (ADL[key]) {
                            options.customVariables[key] = `${key}:${encodeURIComponent(ADL[key])}`;
                        }
                    });

                if (newFSSessionUrl !== '') {
                    options.customVariables.fssessionurl = `fssessionurl:${encodeURIComponent(newFSSessionUrl)}`;
                }
            }

            if (typeof document !== 'undefined' && document.cookie.indexOf(HAV_COOKIE_NAME) !== -1) {
                options.customVariables[HAV_COOKIE_NAME] = `${HAV_COOKIE_NAME}:${encodeURIComponent(this.getCookie(HAV_COOKIE_NAME))}`;
            }

            windowOOo.oo_feedback = new windowOOo.Ocode(options);
            windowOOo.oo_feedback.show(event);
        } else {
            throw new Error('OpinionLab global object not loaded');
        }
    }

    // Attempt to regenerate the FullStory session variable which can get stale
    regenerateFullStorySessionUrl() {
        if (window.dvr && window.dvr.getSessionURL && typeof window.dvr.getSessionURL === 'function') {
            return window.dvr.getSessionURL();
        }

        return '';
    }

    static cleanUpFormElement() {
        const olFormElements = document.querySelectorAll('[target="OnlineOpinion"]');
        if (olFormElements.length) {
            olFormElements.forEach((element) => element.remove());
        }
    }
}

export default OpinionLab;
